(function ($) {
    'use strict';
    Drupal.behaviors.alarms_alerts = {
        attach: function (context, settings) {
            if (context === window.document) {
                $(".atoz a").each(function (index) {
                    if ($($(this).attr('href')).length === 0) {
                        $(this).parent('li').removeClass('color-blu');
                    }
                });
                $(".atoz a").click(function(){
                    $('html,body').animate({
                        scrollTop: $($(this).attr('href')).offset().top
                    }, 500);
                });           
            }
        }
    };
})(jQuery, Drupal);